(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47776],{

/***/ 87417:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestearpluglawyers",
      function () {
        return __webpack_require__(94010);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BestEarplugLawyersHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _components_layouts_bestearpluglawyersWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93653);
/* harmony import */ var _components_bestearpluglawyers_mainBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22720);






const Lawsuit = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 12538).then(__webpack_require__.bind(__webpack_require__, 12538)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(12538)
            ]
    }
});
const About = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 58656).then(__webpack_require__.bind(__webpack_require__, 58656)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(58656)
            ]
    }
});
const Intro = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 259).then(__webpack_require__.bind(__webpack_require__, 259)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(259)
            ]
    }
});
const Defect = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 23980).then(__webpack_require__.bind(__webpack_require__, 23980)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(23980)
            ]
    }
});
const OffersList = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 33124)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33124)
            ]
    }
});
var __N_SSP = true;
function BestEarplugLawyersHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_bestearpluglawyersWrapper__WEBPACK_IMPORTED_MODULE_4__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_bestearpluglawyers_mainBanner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OffersList, {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(About, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Intro, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Defect, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Lawsuit, {})
        ]
    });
}


/***/ }),

/***/ 22720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86276);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);
/* harmony import */ var _components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45464);








function MainBanner() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const isFormDisplayed = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .finalShowForm */ .r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isFormDisplayed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["main-banner"])} mx-auto px-5 lg:max-w-7xl`,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    classes: {
                        formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().form),
                        stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-title"]),
                        stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["step-description"]),
                        formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-button"]),
                        formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["form-field"]),
                        formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["steps-inner"]),
                        fieldsClassName: {
                            radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["radio-field"])
                        },
                        fieldsWrapperClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["fields-wrapper"]),
                        tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tcpa),
                        labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["label-as-step-title"]),
                        formProgressbarClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["progress-background"])
                    },
                    colors: {
                        progressBar: "#b0b0b0"
                    },
                    showProgress: true
                })
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_textBlockOffer_TextBlockOffer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
}


/***/ }),

/***/ 86276:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","wrapper":"styles_wrapper__JCR2s","main-banner":"styles_main-banner__x5J9a","form":"styles_form__e8kf6","steps-inner":"styles_steps-inner__Y73Ne","step-title":"styles_step-title__sgO7e","label-as-step-title":"styles_label-as-step-title__z79hX","step-description":"styles_step-description__R_fuk","fields-wrapper":"styles_fields-wrapper__3Kuzx","form-button":"styles_form-button__FhcPn","form-field":"styles_form-field__n8rOM","radio-field":"styles_radio-field__UDz__","tcpa":"styles_tcpa__qDX92","progress-background":"styles_progress-background__6ZCOT","brief":"styles_brief__9SvHI"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,93653,49774,92888,40179], function() { return __webpack_exec__(87417); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);